import { cx } from '@emotion/css';
import { Select } from '@sortlist-frontend/design-system/legacy';
import { useGroupedExpertises } from '@sortlist-frontend/shared-components';
import { useTranslation } from '@sortlist-frontend/translation/ssr';
import { FC, useMemo } from 'react';

import { Expertise, useExpertises } from '_core/repos/expertises.repo';

import { CustomGroupComponent, CustomMenuList } from './utils';

type ServicesSelectProps = {
  expertises?: Expertise[];
  selectedExpertiseId?: number;
  className?: string;
  handleChange: (expertise: Expertise) => void;
};

export const ExpertiseSelector: FC<ServicesSelectProps> = (props) => {
  const { selectedExpertiseId, handleChange, className, expertises } = props;
  const { t } = useTranslation();

  const { data } = useExpertises();

  const allExpertises = expertises || data;
  const groupedExpertises = useGroupedExpertises(allExpertises);
  const expertisesOptions = groupedExpertises?.map((category, index) => ({
    label: <p className={cx(index > 0 && 'mt-2', 'text-secondary-500 mb-2')}>{category.name}</p>,
    options: category.expertises,
  }));

  const selectedExpertise = useMemo(() => {
    return allExpertises?.find((expertise) => expertise.expertiseId === selectedExpertiseId);
  }, [allExpertises, selectedExpertiseId]);

  return (
    <div className={cx(className)} data-testid="expertise-selector">
      <Select
        placeholder={t('briefing:expertise.placeholder')}
        onChange={(val) => {
          handleChange(val as Expertise);
        }}
        value={selectedExpertise}
        defaultValue={selectedExpertise}
        options={expertisesOptions || []}
        getOptionValue={(option) => (option as Expertise).expertiseId.toString()}
        getOptionLabel={(option) => (option as Expertise).name}
        components={{ MenuList: CustomMenuList, Group: CustomGroupComponent }}
      />
    </div>
  );
};
